export enum EProductActions {
  LOAD_PRODUCTS = '[PRODUCTS] Load Products',
  LOAD_PRODUCTS_SUCCESS = '[PRODUCTS] Load Products Success',
  LOAD_PRODUCTS_ERROR = '[PRODUCTS] Load Products Error',
  REFRESH_PRODUCTS = '[PRODUCTS] Refresh Products',
  CREATE_PRODUCTS = '[PRODUCTS] Create Products',
  CREATE_PRODUCTS_SUCCESS = '[PRODUCTS] Create Products Success',
  CREATE_PRODUCTS_ERROR = '[PRODUCTS] Create Products Error',
  UPDATE_PRODUCTS = '[PRODUCTS] Update Products',
  UPDATE_PRODUCTS_SUCCESS = '[PRODUCTS] Update Products Success',
  UPDATE_PRODUCTS_ERROR = '[PRODUCTS] Update Products Error',
  DELETE_PRODUCTS = '[PRODUCTS] Delete Products',
  DELETE_PRODUCTS_SUCCESS = '[PRODUCTS] Delete Products Success',
  DELETE_PRODUCTS_ERROR = '[PRODUCTS] Delete Products Error',
}

export enum EProductStateStatus {
  INITIALIZING = 'initializing',
  LOADING = 'loading',
  READY = 'ready',
  ERROR = 'error',
  UPDATED = 'updated',
  CRATED = 'created',
}

export interface IProductState {
  status: EProductStateStatus;
  products: IProduct[];
  pagination: IProductPagination;
  currentProduct?: IProduct;
  new_campaign_id?: number;
  error: any;
  update_response?: any;
}

export interface IProduct {
  id: number;
  account_id?: number;
  deleted_at?: string;
  created_at?: string;
  updated_at?: string;
  enabled?: boolean;
  product_name: string;
}

export interface IProductPagination {
  current_page?: number;
  has_more_data?: boolean;
  page_size?: number;
  total_pages_count?: number;
  has_previous?: boolean;
  total_count?: number;
  type?: string;
}
